import { Deserializable } from "../shared/models/deserializable.model";

import { Business } from "../models/business";
import { Account } from "../models/account";

export class BusinessPaymentDetails implements Deserializable {
    id: number;
    label: string;
    sortCode: string;
    accountNumber: string;
    nameOnAccount: string;
    bankName: string;
    paymentInstructions: string;
    isActive: boolean;
    businessId?: number; // Assuming that the relationship includes the business ID
    accountId?: number; // Assuming that the relationship includes the account ID
    Business: Business;
    Account: Account;
  
    constructor() {

    }

    deserialize(input: any) {
        Object.assign(this, input);

        // Business embedded if it has been set
        if (this.Business)
            this.Business = new Business().deserialize(input.Business);

        if (this.Account)
            this.Account = new Account().deserialize(input.Account);

        return this;
    }
  }
  